// The line under the sign-in buttons, as in the Whop modal. The dashboard
// wall and the checkout sheet both show it.
export function SignInTermsLine() {
  return (
    <p className="twt-signin-terms">
      By signing in you agree to our <a href="/terms">terms of service</a>{" "}
      and <a href="/terms#privacy-policy">privacy policy</a>.
    </p>
  );
}
